<template>
	
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		mixins: [validationMixin],
		props: {
			asset: {
				type: Object,
				default: () => ({
					id: null,
					assetNo: null,
					name: null,
					groupId: null,
					description: null,
					manufacturer: null,
					modelNo: null,
					vendor: null,
					costPrice: null,
					warrantyExpirationDate: null,
					notes: null
				})
			},
			isSaving: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {
				form: null,
				assetCategories: []
			};
		},
		computed: {
			assetNoErrors() {
				return [];
			},
			nameErrors() {
				const errors = [];
				if (!this.$v.form.name.$dirty) return errors;
				!this.$v.form.name.required && errors.push('Name is required.');
				return errors;
			},
			serialNoErrors() {
				return [];
			},
			manufacturerErrors() {
				return [];
			},
			modelNoErrors() {
				return [];
			},
			vendorErrors() {
				return [];
			},
			costPriceErrors() {
				return [];
			},
			warrantyExpirationDateErrors() {
				return [];
			},
			descriptionErrors() {
				return [];
			},
			groupIdErrors() {
				return [];
			}
		},
		created() {
			this.form = JSON.parse(JSON.stringify(this.asset));
		},
		methods: {
			onSaveClick() {
				this.$v.form.$touch();

				if (!this.$v.form.$invalid) {
					this.$emit('save', this.form);
				}
			}
		},
		validations: {
			form: {
				name: { required }
			}
		}
	};
</script>
